import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from 'react';
import { BNDLogo } from '../svgs/BNDLogo';
import { Link } from '@jelly/ui';
import { useTheme } from 'emotion-theming';

var BndLogoContainer = /*#__PURE__*/_styled(Link, {
  target: "e1dxuzli0",
  label: "BndLogoContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "13geg62",
  styles: "cursor:pointer;display:block;height:55px;margin:10px 0 20px;max-width:170px;width:250px;"
} : {
  name: "13geg62",
  styles: "cursor:pointer;display:block;height:55px;margin:10px 0 20px;max-width:170px;width:250px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Gb290ZXIvRm9vdGVyTG9nb0JuZC5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTXFDIiwiZmlsZSI6Ii4uLy4uL3NyYy9Gb290ZXIvRm9vdGVyTG9nb0JuZC5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IEJORExvZ28gfSBmcm9tICcuLi9zdmdzL0JORExvZ28nXG5pbXBvcnQgeyBMaW5rIH0gZnJvbSAnQGplbGx5L3VpJ1xuaW1wb3J0IHsgdXNlVGhlbWUgfSBmcm9tICdlbW90aW9uLXRoZW1pbmcnXG5cbmNvbnN0IEJuZExvZ29Db250YWluZXIgPSBzdHlsZWQoTGluaylgXG5cdGN1cnNvcjogcG9pbnRlcjtcblx0ZGlzcGxheTogYmxvY2s7XG5cdGhlaWdodDogNTVweDtcblx0bWFyZ2luOiAxMHB4IDAgMjBweDtcblx0bWF4LXdpZHRoOiAxNzBweDtcblx0d2lkdGg6IDI1MHB4O1xuYFxuXG5leHBvcnQgZnVuY3Rpb24gRm9vdGVyTG9nb0JuZCgpIHtcblx0Y29uc3Qge1xuXHRcdGNvbG9yczogeyB3aGl0ZSB9LFxuXHR9ID0gdXNlVGhlbWUoKVxuXHRyZXR1cm4gKFxuXHRcdDxCbmRMb2dvQ29udGFpbmVyIGhyZWY9XCIvXCI+XG5cdFx0XHQ8Qk5ETG9nbyBjb2xvcj17d2hpdGV9IC8+XG5cdFx0PC9CbmRMb2dvQ29udGFpbmVyPlxuXHQpXG59XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export function FooterLogoBnd() {
  var _useTheme = useTheme(),
      white = _useTheme.colors.white;

  return /*#__PURE__*/React.createElement(BndLogoContainer, {
    href: "/"
  }, /*#__PURE__*/React.createElement(BNDLogo, {
    color: white
  }));
}